// Footer.tsx
import React, { useEffect, useRef } from "react";
import { AppBar, Box, Toolbar, Typography, Link } from "@mui/material";

const Footer: React.FC = () => {
  const footerRef = useRef<HTMLElement>(null);

  // 固定表示のフッターは画面拡大時にリンクが折り返して高くなるため、
  // 実際の高さを CSS 変数 --footer-height として公開し、
  // ページ側で本文がフッターに隠れないよう下余白を確保できるようにする
  useEffect(() => {
    const el = footerRef.current;
    if (!el) return;
    const root = document.documentElement;
    const update = () =>
      root.style.setProperty("--footer-height", `${el.offsetHeight}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.style.removeProperty("--footer-height");
    };
  }, []);

  return (
    <AppBar
      ref={footerRef}
      position="fixed"
      elevation={0}
      sx={{ top: "auto", bottom: 0, width: "100%", zIndex: 1300 }}
    >
      <Box
        sx={{
          boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Toolbar
          sx={{
            backgroundColor: "#ffffff",
            borderTop: "1px solid #CCCCCC",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Box sx={{ mx: 2 }}>
              <Typography color="black">
                <Link href="https://trim.nagoya/">企業情報</Link>
              </Typography>
            </Box>
            <Box sx={{ mx: 2 }}>
              <Typography
                color="black"
                sx={{ borderLeft: "1px solid #000000", paddingLeft: 4 }}
              >
                <Link href="https://trim.nagoya/privacypolicy/">
                  個人情報の取り扱いについて
                </Link>
              </Typography>
            </Box>
            <Box sx={{ mx: 2 }}>
              <Typography
                color="black"
                sx={{ borderLeft: "1px solid #000000", paddingLeft: 4 }}
              >
                <Link href="https://trim.nagoya/information/">
                  お問い合わせ
                </Link>
              </Typography>
            </Box>
            <Box sx={{ mx: 2 }}>
              <Typography
                color="black"
                sx={{ borderLeft: "1px solid #000000", paddingLeft: 4 }}
              >
                © Trim Co., Ltd. All Rights Reserved.
              </Typography>
            </Box>
          </Box>
        </Toolbar>
      </Box>
    </AppBar>
  );
};

export default Footer;
